import { faGear } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ReactElement } from 'react'
import { useRef, useState } from 'react'
import { useDebouncedCallback } from 'use-debounce'
import { InputCol } from '~/components/Form'
import { Label } from '~/components/Form/Input/Label'
import { TextInput } from '~/components/Form/Input/TextInput'
import {
  Button,
  ButtonVariation
} from '~/components/Global/Interactions/Button'
import { Dropdown } from '~/components/Global/Interactions/Dropdown/Dropdown'
import { Toggle } from '~/components/Global/Interactions/Toggle/Toggle'
import { useUpdateConfig } from '~/domains/configuration/mutations/updateConfig'
import { useConfig } from '~/domains/configuration/queries/config'
import type { ConfigName } from '~/domains/configuration/types'
import {
  actionsListOptionLine,
  actionsListOptionLineLabel
} from '../NextActionsBlock/NextActionsBlock.css'

export const ApplicantExperiencesConfigDropdown = (): ReactElement => {
  const [isConfigOpen, setIsConfigOpen] = useState(false)
  const configDropdownRef = useRef<HTMLDivElement>(null)
  const { data: endedSinceDays } = useConfig(
    'dashboard.applicant_experiences_ended_since'
  )
  const configMutation = useUpdateConfig()

  const enabledFilter = endedSinceDays !== undefined && endedSinceDays > 0

  const handleButtonClick = () => {
    setIsConfigOpen(!isConfigOpen)
  }

  const handleConfigSave = useDebouncedCallback(
    (configKey: ConfigName, value: number) => {
      configMutation.mutate({
        name: configKey,
        value
      })
    },
    300
  )

  return (
    <div ref={configDropdownRef} style={{ position: 'relative' }}>
      <Button
        variation={ButtonVariation.Neutral}
        onClick={handleButtonClick}
        narrow
        buttonSize="extraSmall"
      >
        <FontAwesomeIcon icon={faGear} />
      </Button>
      <Dropdown
        isOpen={isConfigOpen}
        dropdownRef={configDropdownRef}
        onclose={() => setIsConfigOpen(false)}
        placement="bottom-end"
      >
        <InputCol>
          <Label className={actionsListOptionLineLabel}>
            Contrats terminés il y a
            <div className={actionsListOptionLine}>
              <Toggle
                defaultState={enabledFilter}
                onChange={(checked) => {
                  if (!checked) {
                    handleConfigSave(
                      'dashboard.applicant_experiences_ended_since',
                      0
                    )
                  } else {
                    handleConfigSave(
                      'dashboard.applicant_experiences_ended_since',
                      7
                    )
                  }
                }}
              />
              <TextInput
                type="number"
                standalone
                small
                min={1}
                max={99}
                defaultValue={endedSinceDays?.toString() ?? '7'}
                onChange={(e) => {
                  const value = Number.parseInt(
                    (e.target as HTMLInputElement).value,
                    10
                  )
                  if (!Number.isNaN(value) && value >= 1 && value <= 99) {
                    handleConfigSave(
                      'dashboard.applicant_experiences_ended_since',
                      value
                    )
                  }
                }}
                disabled={!enabledFilter}
                trailingText="jours"
              />
            </div>
          </Label>
        </InputCol>
      </Dropdown>
    </div>
  )
}
